/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDetailsRequest } from './';
import {
    ProjectDetailsRequestFromJSON,
    ProjectDetailsRequestFromJSONTyped,
    ProjectDetailsRequestToJSON,
} from './';
import type { ProjectDetailsTypeResource } from './';
import {
    ProjectDetailsTypeResourceFromJSON,
    ProjectDetailsTypeResourceFromJSONTyped,
    ProjectDetailsTypeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ShortProjectDetailsRequest
 */
export interface ShortProjectDetailsRequest extends ProjectDetailsRequest {
    /**
     * 
     * @type {number}
     * @memberof ShortProjectDetailsRequest
     */
    budget: number;
}

/**
 * Check if a given object implements the ShortProjectDetailsRequest interface.
 */
export function instanceOfShortProjectDetailsRequest(value: object): value is ShortProjectDetailsRequest {
    if (!('budget' in value) || value['budget'] === undefined) return false;
    return true;
}

export function ShortProjectDetailsRequestFromJSON(json: any): ShortProjectDetailsRequest {
    return ShortProjectDetailsRequestFromJSONTyped(json, false);
}

export function ShortProjectDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShortProjectDetailsRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDetailsRequestFromJSONTyped(json, ignoreDiscriminator),
        'budget': json['budget'],
    };
}

export function ShortProjectDetailsRequestToJSON(value?: ShortProjectDetailsRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDetailsRequestToJSON(value, true),
        'budget': value['budget'],
    };
}

